function Hero() {
  return (
    <section id="hero">
      <div className="hero-title">
        <span className="blink-square" />
        <div className="red-title"> Open to New Opportunities</div>
      </div>
      <p>
        Detail-oriented software engineer with over 11 years of experience in C#
        and C++, specializing in building maintainable systems and tools. My
        career includes 7.5 years in .NET development working on enterprise
        applications and internal tooling, followed by game programming in
        Unreal Engine 5, where I focus on modular gameplay systems, UI
        frameworks, and designer-friendly tools. Comfortable working in
        fast-paced, deadline-driven environments with an emphasis on clean,
        extensible code.
      </p>
    </section>
  );
}

export default Hero;
